/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Modal from "../../../components/Modal";
import YesNoAction from "../../../components/YesNoAction";
import TestIds from "../../../testIds";
import { selectCurrentCart } from "../storage/cart.slice";

interface Props {
  open: boolean;
  handleClose: () => void;
}

interface AlertModalProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  body: string;
  testId?: string;
}
const StockAlertModal = ({ open, handleClose, title, body, testId }: AlertModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal open={open} title={title} handleClose={handleClose} testId={testId}>
      <YesNoAction
        body={body}
        buttonBoxProps={{
          reverse: true,
          sm: {
            flexGrow: 1,
            marginTop: "16px",
          },
        }}
        optionA={{
          label: "Review items",
          testId: `${testId}-review-items`,
          onClick: () => {
            handleClose();
            navigate("products/cart");
          },
        }}
      />
    </Modal>
  );
};

const PickupDeliverySwitchAlert = ({ open, handleClose }: Props) => {
  const cart = useSelector(selectCurrentCart);
  const shouldDisplay = useMemo(() => cart?.items && cart?.items.length > 0, [cart?.pickupStore]);

  if (!shouldDisplay) {
    return null;
  }
  return (
    <StockAlertModal
      open={open}
      handleClose={handleClose}
      title={"Please check your cart"}
      body={"Some of the items in your cart might not be available anymore for this location."}
      testId={TestIds.feat.pickupStoreSwitch.modal}
    />
  );
};

export const StockChangesAlert = ({ open, handleClose }: Props) => {
  return (
    <StockAlertModal
      open={open}
      handleClose={handleClose}
      title={"Product availability has changed"}
      body={"Stock levels may have changed in your cart since your last visit."}
      testId={TestIds.feat.stockChangesAlert.modal}
    />
  );
};

export default PickupDeliverySwitchAlert;
